export default __webpack_public_path__ + "static/media/bats.35a70d2f.svg";